import React, { useState } from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import { Modal, FieldLabel, inputCls, InlineMsg } from "../../apikeys/shared";

const MIN_REASON = 10;

// Confirmation with a mandatory written reason — every rule change is audited and re-runs the pipeline.
export default function ReasonModal({ title, subtitle = "Recorded in the change history · re-runs the pipeline", impact, confirmLabel = "Confirm change",
                                      onConfirm, onClose, testid = "rules-confirm", children, wide = false, blocked = null }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const ok = reason.trim().length >= MIN_REASON && !blocked;

  async function submit(e) {
    e.preventDefault();
    if (!ok || busy) return;
    setBusy(true); setError(null);
    try { await onConfirm(reason.trim()); onClose(); } catch (err) { setError(err.message); setBusy(false); }
  }

  return (
    <Modal title={title} subtitle={subtitle} icon={ShieldAlert} onClose={onClose} busy={busy} testid={testid} wide={wide}>
      <form onSubmit={submit} className="p-5 space-y-3.5">
        {children}
        {impact && <div data-testid={`${testid}-impact`} className="text-[11.5px] border border-border bg-surface-2/50 rounded-sm p-3 leading-snug space-y-1">{impact}</div>}
        <FieldLabel label="Reason for this change (required)" hint={`${reason.trim().length}/${MIN_REASON} min`}>
          <textarea data-testid={`${testid}-reason`} rows={3} value={reason} disabled={busy} autoFocus maxLength={500}
                    onChange={e => setReason(e.target.value)} placeholder="e.g. Steering committee agreed a tighter slow-mover definition."
                    className={`${inputCls} font-sans resize-none`} />
        </FieldLabel>
        {error && <InlineMsg testid={`${testid}-error`}>{error}</InlineMsg>}
        <div className="flex items-center justify-end gap-2 pt-1">
          {blocked && <span data-testid={`${testid}-blocked`} className="mr-auto text-[11px] text-muted">{blocked}</span>}
          <button type="button" onClick={onClose} disabled={busy} data-testid={`${testid}-cancel`}
                  className="px-3 py-1.5 text-[11.5px] border border-border rounded-sm hover:bg-surface-2 disabled:opacity-40">Cancel</button>
          <button type="submit" disabled={!ok || busy} data-testid={`${testid}-submit`}
                  className="px-4 py-1.5 text-[11.5px] font-semibold bg-primary text-primary-fg hover:opacity-90 rounded-sm inline-flex items-center gap-1 disabled:opacity-40">
            {busy && <Loader2 size={11} className="animate-spin" />}{busy ? "Re-running pipeline…" : confirmLabel}
          </button>
        </div>
      </form>
    </Modal>
  );
}
